import { render, staticRenderFns } from "./CreateShipment.vue?vue&type=template&id=232e41f6&scoped=true&"
import script from "./CreateShipment.vue?vue&type=script&lang=js&"
export * from "./CreateShipment.vue?vue&type=script&lang=js&"
import style0 from "./CreateShipment.vue?vue&type=style&index=0&id=232e41f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e41f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('232e41f6')) {
      api.createRecord('232e41f6', component.options)
    } else {
      api.reload('232e41f6', component.options)
    }
    module.hot.accept("./CreateShipment.vue?vue&type=template&id=232e41f6&scoped=true&", function () {
      api.rerender('232e41f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/components/CreateShipment.vue"
export default component.exports